export default __webpack_public_path__ + "static/media/warn.4f2be066.gif";